import * as Mutations from './mutations';
import { PickupOptionsService } from '../../../common/services/settings/pickup-options.service';
import { PaginationParams } from '../../../common/utils/pagination-params';
import { clearAllSelected } from '@/store/modules/page/reset';

export const PickupOptionsModule = {
    state: {
        allPickupOptions: null,
        pickupOptions: null,
        pickupOption: null,
        pickupOptionId: null
    },

    mutations: {
        [Mutations.SET_ALL_PICKUP_OPTIONS] (state, allPickupOptions) {
            state.allPickupOptions = allPickupOptions;
        },

        [Mutations.SET_PICKUP_OPTIONS] (state, pickupOptions) {
            state.pickupOptions = pickupOptions;
        },

        [Mutations.SET_PICKUP_OPTION] (state, pickupOption) {
            state.pickupOption = pickupOption;
        },

        [Mutations.SET_PICKUP_OPTION_ID] (state, id) {
            state.pickupOptionId = id;
        },

        [Mutations.REMOVE_PICKUP_OPTION] (state) {
            state.pickupOption = null;
        },

        [Mutations.REMOVE_PICKUP_OPTION_ID] (state) {
            state.pickupOptionId = null;
        }
    },

    actions: {
        async getPickupOptions(context) {
            const {data: {content, pageable, totalPages, totalElements, numberOfElements}} =
                await PickupOptionsService.getPickupOptions(context.getters.schoolId,
                    PaginationParams.createParams({
                        size: context.getters.pageSize,
                        page: context.getters.pageNumber,
                        sort: context.getters.sortBy,
                        direction: context.getters.direction,
                        query: context.getters.searchQuery,
                        filters: {
                            ...context.getters.filters
                        }
                    }));
            context.commit(Mutations.SET_PICKUP_OPTIONS, content);
            context.dispatch('configPagination', {
                ...pageable,
                numberOfElements,
                totalElements,
                totalPages,
                callback: () => {
                    return context.dispatch('getPickupOptions');
                }
            });
            context.dispatch('resetSelectedItems');
        },

        async getAllPickupOptions(context) {
            const { data } = await PickupOptionsService.getAllPickupOptions(context.getters.schoolId);
            context.commit(Mutations.SET_ALL_PICKUP_OPTIONS, data);
        },

        async getPickupOption(context) {
            const { data } = await PickupOptionsService.getPickupOption(context.getters.schoolId, context.getters.pickupOptionId);
            context.commit(Mutations.SET_PICKUP_OPTION, data);
        },

        async addPickupOption(context, form) {
            try {
                context.dispatch('showSpinner');
                await PickupOptionsService.createPickupOption(context.getters.schoolId, form);
                await context.dispatch('getPickupOptions');
            } finally {
                setTimeout(() => {
                    context.dispatch('hideSpinner');
                });
            }
        },

        async bulkUploadPickupOptions(context, file) {
            await PickupOptionsService.addPickupOptionsBulk(context.getters.schoolId, file);
            await context.dispatch('getPickupOptions');
        },

        async editPickupOption(context, form) {
            try {
                context.dispatch('showSpinner');
                await PickupOptionsService.editPickupOption(context.getters.schoolId, context.getters.pickupOptionId, form);
                await context.dispatch('getPickupOptions');
                context.dispatch('unstagePickupOption');
            } finally {
                context.dispatch('hideSpinner');
            }
        },

        async deletePickupOption(context, pickupOptionId) {
            await context.dispatch('deletePickupOptions', [ pickupOptionId ]);
        },

        async deleteMultiplePickupOptions(context) {
            await context.dispatch('deletePickupOptions', context.getters.selected);
        },

        async deletePickupOptions(context, pickupOptionsIds) {
            await PickupOptionsService.deleteMultiplePickupOptions(context.getters.schoolId, pickupOptionsIds);
            context.dispatch('resetFilter');
            context.dispatch('resetSelectedItems');
            if (pickupOptionsIds.length === context.getters.pickupOptions.length) {
                context.dispatch('openPreviousPage');
            }
            clearAllSelected();
            await context.dispatch('getPickupOptions');
        },

        async togglePickupOptionStatus(context, pickupOptionId) {
            await PickupOptionsService.togglePickupOptionStatus(context.getters.schoolId, pickupOptionId);
            context.dispatch('resetFilter');
            await context.dispatch('getPickupOptions');
        },

        async preparePickupOption(context, payload) {
            if (payload.type === 'edit') {
                context.commit(Mutations.SET_PICKUP_OPTION_ID, payload.pickupOptionId);
                context.dispatch('getPickupOption');
                context.dispatch('openModal', {
                    modalName: 'PickupOptionsModal',
                    callback: () => context.dispatch('unstagePickupOption')
                });
            }
            else {
                context.dispatch('selectedIdItem', payload.pickupOptionId);
                context.dispatch('openModal', {
                    modalName: 'PickupOptionsMigrateChildren',
                    callback: () => context.dispatch('unstagePickupOption')
                });
            }
        },

        unstagePickupOption(context) {
            context.commit(Mutations.REMOVE_PICKUP_OPTION_ID);
            context.commit(Mutations.REMOVE_PICKUP_OPTION);
        },
    },

    getters: {
        allPickupOptions: state => state.allPickupOptions,

        pickupOptions: state => state.pickupOptions,

        pickupOption: state => state.pickupOption,

        pickupOptionId: state => state.pickupOptionId
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/pickup-options/pickup-options.module.js